// Marketing redirect paths -> App Store URLs (query strings kept verbatim).
// Mirrored by the inline <script> at the top of public/index.html so redirects
// fire before the app bundle loads (no flash). Keys are lowercase, no slashes.
export const STORE_REDIRECTS = {
  "tiktok": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=tiktok_bio&mt=8",
  "tiktok-ads": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=tiktok_ads&mt=8",
  "ig": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=instagram_bio&mt=8",
  "ig-ads": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=instagram_ads&mt=8",
  "fb": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=facebook_page&mt=8",
  "fb-ads": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=facebook_ads&mt=8",
  "yt": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=youtube_bio&mt=8",
  "yt-ads": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=youtube_ads&mt=8",
  "x": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=x_bio&mt=8",
  "x-ads": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=x_ads&mt=8",
  "wa": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=whatsapp_share&mt=8",
  "app": "https://apps.apple.com/app/apple-store/id6762446883?pt=127918111&ct=website&mt=8",
};

export const normalizePath = (pathname) =>
  pathname.toLowerCase().replace(/^\/+/, "").replace(/\/+$/, "");
